import { BrowserRouter as Router } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { AuthProvider } from './contexts/AuthContext';
import { ErrorProvider } from './contexts/ErrorContext';
import { TranslationProvider } from './contexts/TranslationContext';
import { GlobalTourProvider } from './contexts/TourContext';
import { GlobalVideoProvider } from './contexts/VideoContext';
import AppContent from './AppContent';
import ThemeWrapper from './components/ThemeWrapper';

function App() {
  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      autoHideDuration={5000}
    >
      <ErrorProvider>
        <AuthProvider>
          <TranslationProvider>
            <GlobalTourProvider>
              <GlobalVideoProvider>
                <ThemeWrapper>
                  <Router>
                    <AppContent />
                  </Router>
                </ThemeWrapper>
              </GlobalVideoProvider>
            </GlobalTourProvider>
          </TranslationProvider>
        </AuthProvider>
      </ErrorProvider>
    </SnackbarProvider>
  );
}

export default App; 